export const environment = {
  name: 'production',
  production: true,
    auth: {
    url:
      'https://mbfo-admin-users.auth.us-east-1.amazoncognito.com',
    callbackUrl: 'https://mbfo-admin.montebravo.com.br/auth',
    region: 'us-east-1',
    userPoolId: 'us-east-1_WDQhEVm62',
    userPoolWebClientId: '7a0teek5bbct58k3mbolu60p9h',
  },
  apiUrl: 'https://mbfo-admin.api.montebravo.com.br',
  features: {
    /** Use here to define feature toggles */
  },
}
